import React from "react";
import { orderType, renderStatusImage } from "../function/store";

const OrderInfo = ({ selected }) => {
  return (
    <div className="info">
      <div className="infoImage">
        <img src={`/img/store/${selected?.orderFlag?.toLowerCase()}.png`} />
      </div>
      <div className="infoText">
        <span>
          {`${orderType[selected?.orderFlag]} - 주문번호: ${selected?.orderId}`}
          {selected?.tableNo && ` (테이블: ${selected?.tableNo})`}
        </span>
        <span>
          {selected?.products?.length && `메뉴 ${selected?.products?.length}개 - `}
          {formatNumber(selected.price)}원
        </span>
      </div>
      {renderStatusImage(selected?.status) && (
        <div className="status">{renderStatusImage(selected?.status)}</div>
      )}
    </div>
  );
};

export default OrderInfo;
